export default __webpack_public_path__ + "static/media/material-ui.ee91f2b1.svg";